export const frontmatter = {
  title: "Claiming Trade Fees Rewards",
  order: 11,
}

Liquidity Providers earn 100% of the Trade Fees generated on the pools they are providing liquidity on.

## Claiming

1. Find the address of the pair you want to claim fees from.
2. Head over to its [BaseScan](https://basescan.org) page.
3. Open the "Contract" tab and select the "Write" tab.
4. Connect your wallet.
5. Scroll down, and click on the **claimFees** button and confirm the transaction!

If you face errors here, check out [Correcting previously generated fees](./fee-on-transfer-tokens)
